"use client";
// Página no encontrada, con la marca y en el idioma de la dirección: lleva a lo más buscado en lugar de dejar a la persona en blanco.
import { usePathname } from "next/navigation";
import { Enlace } from "@/components/Enlace";
import { Img } from "@/components/Img";

export default function NoEncontrada() {
  const es = !usePathname()?.startsWith("/en"), l = es ? "es" : "en";
  const atajos = es
    ? [["Tours", `/${l}/tours`], ["Cabañas", `/${l}/cabanas`], ["Paseos a caballo", `/${l}/caballos`], ["Mi compra", `/${l}/compra`]]
    : [["Tours", `/${l}/tours`], ["Cabins", `/${l}/cabanas`], ["Horseback rides", `/${l}/caballos`], ["My purchase", `/${l}/compra`]];
  return (
    <section className="seccion contenedor no-encontrada">
      <Img src="/media/cleto_piensa.webp" alt="" width={140} height={140} />
      <h1>{es ? "Esta página no existe" : "This page doesn't exist"}</h1>
      <p>{es ? "Puede que la liga esté mal escrita o que la página ya no esté. Desde aquí llegas a lo más buscado:" : "The link may be mistyped or the page was removed. Here's where most people go:"}</p>
      <nav aria-label={es ? "Atajos" : "Shortcuts"}>{atajos.map(([t, h]) => <Enlace key={h} href={h} className="boton fantasma">{t}</Enlace>)}</nav>
      <Enlace href={`/${l}`} className="boton">{es ? "Ir al inicio" : "Go to home"}</Enlace>
    </section>
  );
}
